import React from 'react';
import axios from 'axios';
import cancelIcon from "../../../img/icon/icon-cancel.svg";
import { GetClassChildrenStatus } from "../../../components/common/Common";
const AttendanceChildrens = ({varPopupAttendanceChildrens,onCloseAttendanceChildrenHandler,varChildrenList,setChildrenList}) => {
  //출/결석처리
  const onAttendanceHandler = async(e,children,imode) => {
    const sendData = {dataInfo:children,csc_status:imode};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_attendance`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const copyList = [...varChildrenList];
        const findIndex = copyList.findIndex(el=>el.idx===children.idx);
        copyList[findIndex].cstate = imode;
        setChildrenList(copyList);
      }
    });
  }

  return (
    <div className="layer-pop" style={varPopupAttendanceChildrens?{display:"block"}:{display:"none"}}>
      <div className="attendance-pop">
        <div className="layer-hd">
          <div className="tit">출석 인증</div>
          <div className="close-layer" onClick={(e)=>onCloseAttendanceChildrenHandler(e)}><img src={cancelIcon} alt=""/></div>
        </div>
        <div className="popup-content" style={{height:"300px",overflowY:"scroll"}}>
          <div className="attendance-list">
            {varChildrenList.map((children,i)=>(
              <div className="attendance-item" key={'children_'+i}>
                <span className="student-name">
                  <div style={{marginTop:"4px"}}>{children.name}&nbsp;({children.months})</div>&nbsp;&nbsp;{GetClassChildrenStatus(children.cstate)}</span>
                <div>
                  <button className="attendance-btn present" onClick={e=>onAttendanceHandler(e,children,2)}>출석</button>
                  <button className="attendance-btn absent" onClick={e=>onAttendanceHandler(e,children,3)}>결석</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AttendanceChildrens;